module.exports = __webpack_public_path__ + "media/img/naped-przod@3x-e72a61e5.svg";